import * as React from 'react';
import { ChaptersChart } from "./ChaptersChart";
import { QuestionCharts } from "./QuestionCharts";
import { PdfDownloadButton } from "./PdfDownloadButton";
import { ChartDataContext } from "../context/Chart";
import { Spinner } from "./Spinner";

export const Charts = (): JSX.Element => {

    const [chartdata,] = React.useContext(ChartDataContext);

    return <div className={'c-rstats__charts'}>
        {chartdata.fetching && (<Spinner title={'Bezig met het ophalen van de gegevens'}/>)}
        <PdfDownloadButton/>
        {chartdata.initialized && (<>
            <ChaptersChart/>
            <QuestionCharts/>
        </>)}
        <PdfDownloadButton/>
    </div>;
}
